export default {
      id: "nestle-usage",
      viewBox: "0 0 172 50",
      url: __webpack_public_path__ + "sprite.svg#nestle-usage",
      toString: function () {
        return this.url;
      }
    }